// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddSeller_pageWrap__0m8P0 {
  padding: 4px 4px 32px;
}

.AddSeller_sectionTitle__lN99V {
  font-family: 'Sora', 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #4c2fb3;
  margin: 26px 0 14px;
  padding-top: 14px;
  border-top: 1px solid #EEF0F6;
}
.AddSeller_sectionTitle__lN99V:first-child {
  margin-top: 0;
  padding-top: 0;
  border-top: none;
}

.AddSeller_hintText__9w3lO {
  font-size: 11.5px;
  color: #9CA3AF;
  margin-left: 6px;
}

.AddSeller_verifiedTag__g9mg\\+ {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  color: #16A34A;
  font-size: 11px;
  font-weight: 700;
  margin-left: 8px;
}

.AddSeller_submitRow__CqwpM {
  display: flex;
  justify-content: center;
  margin-top: 28px;
}

/* Light violet-themed polish for the multiselect-react-dropdown library's
   default markup, without fighting its internal styling. */
.AddSeller_field__s6flx .multiSelectContainer .searchWrapper {
  border: 1px solid #E5E7EB !important;
  border-radius: 10px !important;
  padding: 6px 10px !important;
}
.AddSeller_field__s6flx .multiSelectContainer .searchWrapper input {
  font-size: 13.5px;
}
.AddSeller_field__s6flx .multiSelectContainer .optionListContainer {
  border-radius: 10px !important;
  border: 1px solid #E7E9F1 !important;
  box-shadow: 0 12px 28px rgba(27, 37, 89, 0.12) !important;
}
.AddSeller_field__s6flx .multiSelectContainer .highlightOption,
.AddSeller_field__s6flx .multiSelectContainer li:hover {
  background: #F5F3FE !important;
  color: #4c2fb3 !important;
}
.AddSeller_field__s6flx .multiSelectContainer .chip {
  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%) !important;
  border-radius: 20px !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/addseller/AddSeller.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;2DAC2D;AAC3D;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,4BAA4B;AAC9B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yDAAyD;AAC3D;AACA;;EAEE,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,wEAAwE;EACxE,8BAA8B;AAChC","sourcesContent":[".pageWrap {\n  padding: 4px 4px 32px;\n}\n\n.sectionTitle {\n  font-family: 'Sora', 'Inter', sans-serif;\n  font-size: 14px;\n  font-weight: 700;\n  color: #4c2fb3;\n  margin: 26px 0 14px;\n  padding-top: 14px;\n  border-top: 1px solid #EEF0F6;\n}\n.sectionTitle:first-child {\n  margin-top: 0;\n  padding-top: 0;\n  border-top: none;\n}\n\n.hintText {\n  font-size: 11.5px;\n  color: #9CA3AF;\n  margin-left: 6px;\n}\n\n.verifiedTag {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  color: #16A34A;\n  font-size: 11px;\n  font-weight: 700;\n  margin-left: 8px;\n}\n\n.submitRow {\n  display: flex;\n  justify-content: center;\n  margin-top: 28px;\n}\n\n/* Light violet-themed polish for the multiselect-react-dropdown library's\n   default markup, without fighting its internal styling. */\n.field :global(.multiSelectContainer .searchWrapper) {\n  border: 1px solid #E5E7EB !important;\n  border-radius: 10px !important;\n  padding: 6px 10px !important;\n}\n.field :global(.multiSelectContainer .searchWrapper input) {\n  font-size: 13.5px;\n}\n.field :global(.multiSelectContainer .optionListContainer) {\n  border-radius: 10px !important;\n  border: 1px solid #E7E9F1 !important;\n  box-shadow: 0 12px 28px rgba(27, 37, 89, 0.12) !important;\n}\n.field :global(.multiSelectContainer .highlightOption),\n.field :global(.multiSelectContainer li:hover) {\n  background: #F5F3FE !important;\n  color: #4c2fb3 !important;\n}\n.field :global(.multiSelectContainer .chip) {\n  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%) !important;\n  border-radius: 20px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrap": `AddSeller_pageWrap__0m8P0`,
	"sectionTitle": `AddSeller_sectionTitle__lN99V`,
	"hintText": `AddSeller_hintText__9w3lO`,
	"verifiedTag": `AddSeller_verifiedTag__g9mg+`,
	"submitRow": `AddSeller_submitRow__CqwpM`,
	"field": `AddSeller_field__s6flx`
};
export default ___CSS_LOADER_EXPORT___;
